import React, { Component } from 'react';

import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import ActionDescription from 'material-ui/svg-icons/action/description';
import MenuItem from 'material-ui/MenuItem';

class SimpleLinkButton extends Component {
  render() {
    return (
      <IconMenu
        iconButtonElement={
          <IconButton touch={true}>
            <ActionDescription
              color={"rgb(0, 121, 107)"}
            />
          </IconButton>
        }
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        targetOrigin={{horizontal: 'right', vertical: 'top'}}
      >
        <MenuItem
          primaryText="Single Page View"
          onTouchTap={()=>this.props.gotoResume()}
        />
        <MenuItem
          primaryText="Single Page Expanded View"
          onTouchTap={()=>this.props.gotoResumeExpanded()}
        />
        <MenuItem
          primaryText="Simple PDF"
          onTouchTap={()=>this.props.gotoPDF()}
        />
      </IconMenu>
    );
  }
}

export default SimpleLinkButton;



// WEBPACK FOOTER //
// ./src/components/SimpleLinkButton.js